var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartBgGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1868,
    height: 130,
    viewBox: "0 0 1868 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9378_177920)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1868,
    height: 148,
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 774.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 828.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 846.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 918.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 954.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 972.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1026.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1044.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1098.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1116.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1134.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1188.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1206.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1278.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1314.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1332.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1350.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1386.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1404.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1422.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1458.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1476.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1494.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1512.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1566.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1584.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1602.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1638.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1656.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1674.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1692.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1728.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1746.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1764.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1782.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1800.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1836.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1854.25,
    y: 0.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 774.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 828.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 846.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 918.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 954.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 972.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1026.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1044.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1098.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1116.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1134.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1188.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1206.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1278.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1314.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1332.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1350.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1386.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1404.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1422.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1458.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1476.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1494.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1512.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1566.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1584.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1602.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1638.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1656.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1674.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1692.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1728.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1746.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1764.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1782.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1800.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1836.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1854.25,
    y: 18.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 774.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 828.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 846.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 918.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 954.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 972.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1026.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1044.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1098.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1116.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1134.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1188.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1206.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1278.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1314.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1332.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1350.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1386.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1404.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1422.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1458.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1476.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1494.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1512.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1566.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1584.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1602.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1638.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1656.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1674.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1692.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1728.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1746.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1764.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1782.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1800.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1836.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1854.25,
    y: 36.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 774.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 828.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 846.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 918.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 954.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 972.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1026.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1044.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1098.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1116.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1134.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1188.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1206.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1278.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1314.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1332.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1350.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1386.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1404.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1422.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1458.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1476.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1494.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1512.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1566.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1584.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1602.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1638.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1656.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1674.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1692.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1728.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1746.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1764.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1782.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1800.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1836.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1854.25,
    y: 54.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 774.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 828.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 846.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 918.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 954.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 972.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1026.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1044.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1098.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1116.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1134.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1188.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1206.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1278.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1314.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1332.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1350.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1386.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1404.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1422.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1458.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1476.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1494.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1512.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1566.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1584.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1602.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1638.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1656.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1674.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1692.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1728.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1746.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1764.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1782.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1800.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1836.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1854.25,
    y: 72.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 774.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 828.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 846.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 918.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 954.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 972.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1026.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1044.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1098.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1116.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1134.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1188.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1206.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1278.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1314.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1332.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1350.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1386.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1404.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1422.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1458.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1476.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1494.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1512.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1566.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1584.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1602.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1638.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1656.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1674.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1692.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1728.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1746.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1764.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1782.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1800.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1836.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1854.25,
    y: 90.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 774.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 828.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 846.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 918.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 954.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 972.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1026.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1044.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1098.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1116.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1134.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1188.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1206.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1278.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1314.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1332.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1350.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1386.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1404.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1422.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1458.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1476.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1494.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1512.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1566.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1584.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1602.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1638.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1656.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1674.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1692.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1728.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1746.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1764.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1782.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1800.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1836.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1854.25,
    y: 108.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 774.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 828.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 846.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 918.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 954.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 972.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 990.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1026.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1044.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1062.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1098.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1116.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1134.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1188.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1206.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1242.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1260.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1278.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1314.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1332.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1350.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1386.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1404.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1422.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1440.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1458.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1476.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1494.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1512.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1566.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1584.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1602.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1620.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1638.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1656.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1674.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1692.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1710.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1728.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1746.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1764.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1782.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1800.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1818.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1836.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1854.25,
    y: 126.25,
    width: 17.5,
    height: 17.5,
    fill: "#2F2F2F",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9378_177920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1868,
    height: 148,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBgGray);
export default __webpack_public_path__ + "static/media/chart_bg_gray.85d1c859a92b257107dd95ad88dbc825.svg";
export { ForwardRef as ReactComponent };